export const CONNECTING = 'CONNECTING' // Discando
export const CONNECTED = 'CONNECTED' // Andamento
export const CONFERENCE = 'CONFERENCE' // Andamento
export const DISCARDED = 'DISCARDED' // Andamento
export const ENDED = 'ENDED' // Encerrada
export const HOLD = 'HOLD' // Espera
export const RINGING = 'RINGING' // Tocando
export const COMPLETED = 'COMPLETED' // Completada
export const ANSWERING = 'ANSWERING'
export const OFFERING = 'OFFERING'
export const SEND_DONE = 'SEND_DONE'
export const LOSED = 'LOSED'
